export default {
    navHome: "Home",
    navProspect: "Prospects",
    navCompanies: 'Companies',
    navEnrich: 'Enrich',
    navIntent: "Website Intent",
    navSequence: "Sequence",
    navInbox: "Inboxes",
    navService: "Services",
    navSectionDiscover: "Discover",
    navSectionEngage: "Engage",
    navSectionAccount: "Account",
    navAccountCredit: "Account credit",
    navSetting: "Setting",
    navSequenceDetail: "Sequence detail",
    companyDetail: "Company Detail",



    // nav desc
    filterYourSearchToFindPreciselyTargeted: "Filter your search to find precisely targeted lists of companies",
    filterYourSearchToFindHighlySpecific: "Filter your search to find highly specific groups of targeted leads",
    instantlyEnhanceYourData: "Instantly enhance your data by adding valuable insights and key details from various sources",
    transformAnonymousWebsiteTrafficInto: "Transform anonymous website traffic into B2B leads with real-time identification",
    personalizeYourOutreach: 'Automate and personalize your outreach to save time and engage your prospects',
    navInboxDesc: 'Read replies and respond from one place across email and LinkedIn',
    comprehensiveBusinessSolutions: 'Comprehensive business solutions and support services for your needs',

    // Inbox view strings
    inboxSearchPlaceholder: "Search conversations",
    inboxEmptyState: "No conversations yet. Replies will show up here once your sequences start.",
    inboxEmptyConnectCta: "Set up a sequence",
    channelEmail: "Email",
    channelLinkedIn: "LinkedIn",
    inboxMsgYou: "You",
    inboxSelectThreadTitle: "Pick a conversation",
    inboxThreadErrorTitle: "Couldn't load this conversation",
    inboxThreadErrorHint: "The thread has no live channel connection or the data is no longer available.",
    inboxComposerHint: "Press ⌘ + Enter to send",
    inboxToggleProspect: "Toggle prospect details",
    inboxChannelFilter: "Channel filter",
    inboxProspectContact: "Contact",
    inboxProspectSequence: "Sequence",
    inboxProspectActivity: "Activity",
    inboxProspectLastInbound: "Last reply",
    inboxProspectLastOutbound: "Last sent",
    inboxProspectStatus: "Status",
    inboxProspectNoContact: "No contact info available.",
    inboxBulkSelected: "selected",
    inboxBulkMarkRead: "Read",
    inboxBulkToggle: "Select conversation",
    inboxTabProfile: "Profile",
    inboxTabActivity: "Activity",
    inboxActivityEmpty: "No activity yet for this conversation.",
    inboxInsertVariable: "Variable",
    inboxVarFullName: "Full name",
    inboxVarCompany: "Company",
    inboxVarTitle: "Title",
    inboxSequenceStep: "Step",
    inboxSequenceRunning: "Running",
    inboxSequencePaused: "Paused",
    inboxSequenceFinished: "Finished",
    inboxSequenceArchived: "Archived",
    inboxProspectSequences: "Sequences",
    inboxSequenceOpen: "Open",
    inboxSequenceHoverHint: "Hover for steps",
    inboxSequenceCompleted: "Completed",
    inboxSequenceStepsWord: "steps",
    inboxSequenceStepDone: "Sent",
    inboxSequenceStepStarted: "Started",
    inboxSequenceStepPassed: "Passed",
    inboxSequenceStepCurrent: "Current step",
    inboxSequenceStepUpcoming: "Upcoming",
    inboxMinShort: "m",
    inboxHourShort: "h",
    inboxDayShort: "d",
    inboxSequenceProgress: "Progress",
    inboxReplied: "Replied",
    inboxSequenceNext: "Next",
    inboxSequenceNextStep: "Next step",
    inboxSequenceActive: "Active",
    inboxSequenceAllDone: "Sequence completed",
    inboxSequencePausedReply: "Paused — they replied",
    inboxSequencePausedHint: "Paused",
    inboxJustNow: "just now",
    inboxAgo: "ago",
    inboxIn: "in",
    inboxSequenceUpNext: "Up next",
    inboxSequenceStatus: "Status",
    inboxSequenceWait: "Wait",
    inboxSequenceNothingMore: "Finished — nothing more will send",
    inboxSequencePausedNothing: "Paused — won't send until you resume",
    inboxSequenceFinishingSoon: "Last step — finishing soon",
    inboxSequenceDueNow: "due now",
    inboxSequenceClickNode: "Click a step to see its details",
    inboxSequenceActionTimeout: "This took too long — please try again.",
    inboxSequenceLoadingSteps: "Loading steps…",
    inboxSequenceViewWorkflow: "View workflow",
    inboxSequenceLoadingWorkflow: "Loading workflow…",
    inboxSequenceWorkflowError: "Couldn't load this workflow.",
    inboxSequenceNoWorkflow: "No workflow to show.",
    inboxSequenceReadOnly: "Read-only view",
    inboxSequenceEditInBuilder: "Edit in builder",
    inboxSequenceAfter: "after",
    inboxActionResumeSequence: "Resume sequence",
    inboxToastSequenceResumed: "Sequence resumed",
    inboxStatsToday: "Today",
    inboxStatsReplies: "Replies",
    inboxStatsPending: "Pending",
    inboxStatsActiveSequences: "Active sequences",
    inboxOpenEmpty: "Open the inbox to see your latest replies.",
    inboxAsideConversations: "conversations",
    inboxBulkToggleAll: "Select all on this page",
    inboxSortBy: "Sort",
    inboxSortRecent: "Newest first",
    inboxSortOldest: "Oldest first",
    inboxSortSender: "Sender (A→Z)",
    inboxSortSubject: "Subject (A→Z)",
    last_message_at: "Last message",
    first_message_at: "First message",
    reference_id: "Sender",
    subject: "Subject",
    inboxAccountSingular: "account",
    inboxAccountPlural: "accounts",
    inboxRecentReplies: "Recent replies",
    inboxRefresh: "Refresh inbox",
    inboxSortReplied: "Replied first",
    inboxConnectedAs: "Connected as",
    inboxActionInterested: "Mark as interested",
    inboxActionMarkAll: "Mark all",
    inboxSelectThreadHint: "Select a conversation to view its messages.",
    inboxReplyPlaceholder: "Type a reply…",
    inboxSuggestReply: "Suggest reply",
    inboxSuggestFollowUp: "Suggest follow-up",
    inboxInsightAge: "Age",
    inboxSuggestModePick: "Choose draft type",
    inboxSuggestModeReply: "Reply (prospect wrote last)",
    inboxSuggestModeFollowUp: "Follow-up (we wrote last)",
    inboxSuggestModeAuto: "Auto (detect from thread)",
    inboxSend: "Send",
    inboxFilterAll: "All",
    inboxFilterUnread: "Unread",
    inboxFilterReplied: "Replied",
    inboxFilterSnoozed: "Snoozed",
    inboxFilterClosed: "Closed",
    inboxFilterArchived: "Archived",
    inboxFilterDone: "Done",
    // Status taxonomy — STATE NOUNS (used in the Filter panel). Action verbs ("Mark as
    // …") only appear in the Actions menu. Keeping the two vocabularies distinct.
    inboxStatusMeetingBooked: "Meeting booked",
    inboxStatusNotInterested: "Not interested",
    inboxStatusInterested: "Interested",
    // "Active" instead of "Open" to avoid overlap with the email Opens metric
    // (status vs count). Matches Pubrio's Sequence_Target_Status_Types vocabulary
    // where the default state is `active`.
    inboxFilterOpen: "Active",
    inboxMsgSent: "Sent",
    inboxClickToOpen: "Click to open",
    inboxKpiSentToday: "Sent today",
    inboxKpiUnread: "Unread",
    inboxKpiRepliedToday: "Replies",
    inboxKpiSentWeek: "Sent this week",
    inboxKpiInbox: "in inbox",
    inboxKpiTotal: "total",
    inboxGlanceTopSequences: "Top sequences (30 days)",
    inboxLinkBtn: "Link",
    inboxLinkPromptUrl: "Link URL",
    inboxLinkPromptErr: "Enter a URL starting with http(s)://",
    inboxComposerDropHint: "Drop to attach",
    inboxFilterChannel: "Channel",
    inboxFilterCredential: "Credential",
    inboxFilterSequence: "Sequence",
    inboxFilterStatus: "Status",
    inboxFilterClassification: "Reply type",
    inboxFilterDateRange: "Date range",
    inboxFilterDateRangePh: "Pick a date range",
    inboxFilterClass_real: "Real replies only",
    inboxFilterClass_bounce: "Bounces",
    inboxFilterClass_auto_reply: "Auto-replies",
    inboxClassBounce: "Bounce",
    inboxClassBounceHint: "Delivery failed — this isn't a real reply",
    inboxClassAutoReply: "Auto-reply",
    inboxClassAutoReplyHint: "Automated out-of-office / vacation responder",
    inboxStepEvents: "events",
    inboxBulkMarkUnread: "Unread",
    inboxBulkInterested: "Interested",
    inboxBulkNotInterested: "Not interested",
    inboxSnoozeDialogTitle: "Snooze until",
    inboxSnoozeCustom: "Pick a custom date and time",
    inboxSnoozeCustomPh: "Select date & time",
    inboxSnoozeConfirm: "Snooze",
    inboxSnoozePreset1h: "Later today (1h)",
    inboxSnoozePreset4h: "Later today (4h)",
    inboxSnoozePresetTom: "Tomorrow morning",
    inboxSnoozePresetMon: "Next Monday",
    inboxSnippetBtn: "Snippets",
    inboxSnippetSearch: "Search snippets",
    inboxSnippetNew: "New snippet",
    inboxSnippetManage: "Manage",
    inboxSnippetCreate: "Create your first snippet",
    inboxSnippetCreateTitle: "New snippet",
    inboxSnippetEditTitle: "Edit snippet",
    inboxSnippetManager: "Manage snippets",
    inboxSnippetEmpty: "No saved snippets yet.",
    inboxSnippetFieldName: "Name",
    inboxSnippetFieldChannel: "Channel (optional)",
    inboxSnippetFieldBody: "Body",
    inboxSnippetChannelAny: "Any channel",
    inboxSnippetNamePh: "e.g. Friendly follow-up",
    inboxSnippetBodyPh: "Hi {{first_name}}, just following up…",
    btnSave: "Save",
    inboxProspectTracking: "Tracking",
    inboxOpened: "Opened",
    inboxClicked: "Clicked",
    inboxLast: "last",
    of: "of",
    inboxAttachBtn: "Attach",
    inboxAttachTooBig: "Total attachment size exceeds 24MB.",
    noData: "No results",
    inboxCopy: "Copy",
    inboxCopied: "Copied",
    inboxCopyEmail: "Copy email",
    inboxCopiedEmail: "Email copied",
    inboxCopyPhone: "Copy phone",
    inboxCopiedPhone: "Phone copied",
    inboxOpenLinkedIn: "Open LinkedIn",
    inboxOpenTwitter: "Open X / Twitter",
    inboxProspectCompany: "Company",
    inboxProspectInsights: "Insights",
    inboxInsightMessages: "Messages",
    inboxInsightSince: "Open",
    inboxAgeToday: "Today",
    inboxEmptyTitle: "No conversations yet",
    inboxSelectionPicker: "Selection options",
    inboxSelectionTitle: "Select conversations",
    inboxSelectThisPage: "This page",
    inboxSelectAll: "All conversations",
    inboxSelectCustom: "Custom",
    inboxSelectAllHint: "Selecting beyond this page fetches additional pages from the server.",
    applySelection: "Apply",
    theQuantityCannotBeZero: "Pick a non-zero count",
    inboxCompanyName: "Name",
    inboxCompanyIndustry: "Industry",
    inboxCompanySize: "Size",
    inboxCompanyLocation: "Location",
    inboxCompanyWebsite: "Website",
    inboxCompanyLinkedIn: "LinkedIn",
    inboxActionSnooze: "Snooze",
    inboxActionMeetingBooked: "Mark meeting booked",
    inboxActionNotInterested: "Mark not interested",
    inboxActionArchive: "Archive",
    inboxActionStopSequence: "Stop sequence",
    inboxArchetypeConcise: "Concise",
    inboxArchetypeWithCta: "With CTA",
    inboxArchetypeQuestionBack: "Question back",
    inboxShowTrimmed: "Show trimmed content",
    inboxShowTrimmedHint: "Show the rest of this message",
    // Composer header fields — Gmail-style To / Cc / Bcc / Subject row above the editor.
    // Only rendered when the active channel supports them (see channel-config.js).
    inboxFieldTo: "To",
    inboxFieldToPh: "recipient@example.com",
    inboxFieldToLinkedInPh: "Recipient",
    inboxFieldCc: "Cc",
    inboxFieldCcPh: "cc@example.com, …",
    inboxFieldBcc: "Bcc",
    inboxFieldBccPh: "bcc@example.com, …",
    inboxFieldSubject: "Subject",
    inboxFieldSubjectPh: "Subject",
    inboxFieldLocked: "Auto-filled — cannot edit",
    // Per-conversation tracking strip — small chip row above the messages with
    // aggregate numbers for the whole thread. Quiet by default; lights up when a
    // metric is non-zero so users can scan thread state at a glance.
    inboxTrackSent: "Sent",
    inboxTrackSentHint: "Messages we sent in this thread",
    inboxTrackReplies: "Replies",
    inboxTrackRepliesHint: "Inbound messages from the prospect",
    inboxTrackOpens: "Opens",
    inboxTrackOpensHint: "Times the recipient opened a tracked message",
    inboxTrackClicks: "Clicks",
    inboxTrackClicksHint: "Tracked links the recipient clicked",
    // LinkedIn-specific engagement vocabulary (matches what LinkedIn surfaces
    // in its own UI — users recognize "read receipts" and "reactions").
    inboxTrackReads: "Reads",
    inboxTrackReadsHint: "Times the recipient read this thread (LinkedIn read receipts)",
    inboxTrackReactions: "Reactions",
    inboxTrackReactionsHint: "Reactions on our outbound messages",
    inboxMsgNoOpenYet: "No opens recorded yet",
    inboxMsgNoClickYet: "No clicks recorded yet",
    // Activity timeline event labels — surface what the recipient did (reply, open,
    // click) alongside what we sent. Backend kinds are snake_case; we humanise here.
    inboxActivityReplyReceived: "Reply received",
    inboxActivityOpenRecorded: "Email opened",
    inboxActivityClickRecorded: "Link clicked",
    inboxActivitySendEmail: "Email sent",
    inboxActivitySendLinkedIn: "LinkedIn message sent",
    inboxActivitySendInvite: "LinkedIn invite sent",
    inboxActivityFailed: "failed",
    // Composer expand/collapse toggle (Gmail "popout" pattern) — when expanded the
    // editor takes most of the convo pane for focused writing, collapse to see thread.
    inboxComposerExpand: "Expand composer",
    inboxComposerCollapse: "Collapse composer",
    inboxComposerMinimise: "Minimise composer",
    inboxComposerRestore: "Restore composer",
    inboxComposerReply: "Reply…",
    // Reply mode picker (Reply / Reply-all). Only shown when extra recipients exist.
    inboxReplyModeReply: "Reply",
    inboxReplyModeReplyAll: "Reply all",
    // Recipient token input
    inboxRecipientNoMatch: "Type an email and press Enter",
    // Signature (localStorage-backed until backend signature column exists)
    inboxSignatureToggle: "Toggle signature",
    inboxSignatureTitle: "Email signature",
    inboxSignaturePh: "Best regards,\nYour name",
    inboxSignatureOn: "Signature ON — click to remove",
    inboxSignatureOff: "Signature OFF — click to insert",
    inboxSignatureRightClickEdit: "right-click to edit",
    inboxSignatureRightClickHint: "Tip: right-click the signature button to edit.",
    actions: "Actions",
    loading: "Loading…",


    discoverAndConnectWithPotentialBuyers: "Discover and connect with potential buyers",
    activelySeekingYourSolutionToday: "actively seeking your solution today",
    Market_Intent: "Market Intent",
    Tools: "Tools",
    technologyLookup: "Technology Lookup",
    domainLookup: "Domain Lookup",
    emailVerification: "Email Verification",
    upgrade: "Upgrade",
    replayMonitorTour: "Replay Monitor tour",
    replayOnboardingTour: "Replay onboarding tour",
    tourDuration: "2 min",
    helpCenter: "Help Center",
    contactUs: "Contact Us",
    feedback: "Feedback",
    hello: "Hello",
    clickToChange: "Click to change",
    yourProfile: "Your Profile",
    currentUsage: "Current Usage",
    upgradePlan: "Upgrade Plan",
    integrations: "Integrations",
    featureRequests: "Feature Requests",
    change: "change",
    en: "English",
    cn: "中文（简）",
    tw: "中文（繁）",
    logout: "Log Out",
    switchLanguage: "Switched Language successfully",

    // button operation
    btnEdit: "Edit",
    btnDelete: "Delete",
    btnCancel: 'Cancel',
    btnFilters: "Filters",
    btnView: 'view',
    btnAdd: 'Add',
    btnRemove: 'Remove',

    // 操作提示
    removeSuccessfully: "Remove Successfully",
    saveSuccessfully: "Save Successfully",
    createSuccessfully: "create Successfully",


    // 系统popup
    unableToProcessPayment: 'Unable to process payment: Payment could not be completed on your most recent invoice.',
    billingSettings: "Billing Settings",

    // wallet
    topupCredit: "Top-up Credit",
    autoTopup:"Auto top-up",
    lastCalculated: "Last calculated",
    Enabled: "Enabled",
    Disabled: "Disabled",

    // user
    btnUpgrade: "Upgrade",

    // generic short labels
    Refresh: "Refresh",
    Reload: "Reload",
    Show: "Show",
    Hide: "Hide",
    Next: "Next",

    // app update toast
    newVersionAvailable:
      "<strong>A new version is available</strong> — Reload to get the latest features and fixes. Your unsaved changes on this page may be lost.",

    // pagination
    pagination_per_page: "{size} / page",
    pagination_go_to: "Go to",
};